export default "__VITE_ASSET__CrzlW1Jn__"